export default __webpack_public_path__ + "static/media/tpa-microsoft.51034c72.png";